import React, { Component } from "react";

export class WorkLocationModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.WorkLocationModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, show, onClose, modalSize } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppCanvas
        id={id}
        title={title}
        show={show}
        onClose={onClose}
        modalSize={modalSize}
      >
        <AppFormData {...attrs} onClose={onClose}></AppFormData>
      </AppCanvas>
    );
  }
}

export default WorkLocationModal;
